import { Component, OnInit, Inject } from '@angular/core';
import { TimeService } from 'src/app/time.service';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

@Component({
  selector: 'app-payment-voucher-view',
  templateUrl: './payment-voucher-view.component.html',
  styleUrls: ['./payment-voucher-view.component.scss']
})
export class PaymentVoucherViewComponent implements OnInit {

  voucherData: any = {};
  currencySymbol = '₹';
  constructor(public timeService: TimeService, private dialog: MatDialogRef<PaymentVoucherViewComponent>,
              @Inject(MAT_DIALOG_DATA) public parentData: any) { }

  ngOnInit() {
    this.voucherData.voucher_no = this.parentData.no;
    this.voucherData.date_of_payment = (this.parentData.payment_date) ? this.timeService.toShortDate(this.parentData.payment_date) : 'N/A';
    this.voucherData.creation_date = (this.parentData.created_date) ? this.timeService.toShortDate(this.parentData.created_date) : 'N/A';
    this.voucherData.payee = this.parentData.payee || 'N/A';
    this.voucherData.debit = this.parentData.debit || 'N/A';
    this.voucherData.credit = this.parentData.credit || 'N/A';
    this.voucherData.amount = this.parentData.amount || 'N/A';
    this.voucherData.narration = this.parentData.narration || 'N/A';
    this.voucherData.docs = this.parentData.docs || [];
  }

  closeModal() {
    this.dialog.close();
  }
}
